import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'showNavbar',
    pure: true,
    standalone: false
})
export class ShowNavbarPipe implements PipeTransform {
  transform(siteFound: boolean, route: string): boolean {
    const pagesWithoutNavbar = ['/invalid', 'login'];
    return siteFound && !pagesWithoutNavbar.includes(route);
  }
}
